module.exports = __webpack_public_path__ + "img/bloqhouse.2a9489bf.png";